import './action-bar.scss';

import { faClock, faListAlt } from '@fortawesome/free-regular-svg-icons';
import {
    faClock as faSolidClock,
    faCogs,
    faHome,
    faListAlt as faSolidListAlt,
} from '@fortawesome/free-solid-svg-icons';
import { Component, Watch } from 'vue-property-decorator';

import { MovementDataStore, TaskDataStore } from '@skinsoft/entity';
import { ReactiveVue } from '@skinsoft/reactive-vue';

import { SideMenu } from '@skinsoft/ui';
import { FORCE_CLOSE_MENU_TOPIC, TOGGLE_MENU_TOPIC } from '../../../busTopics';
import { router, Routes } from '../../../router';

@Component({
    components: {
        sSideMenu: SideMenu
    },
    template: require('./action-bar.html'),
})
export class ActionBar extends ReactiveVue {
    public homeIcon = faHome;
    public menuIcon = faCogs;
    public clockIcon = faClock;
    public solidClockIcon = faSolidClock;
    public listIcon = faListAlt;
    public solidListIcon = faSolidListAlt;
    public $route;

    public movementCount: number = 0;
    public taskCount: number = 0;
    public menuOpened: boolean = false;
    public routeHasMenu: boolean = false;

    public $movementDataStore: MovementDataStore;
    public $taskDataStore: TaskDataStore;

    public toggleSideMenuTopic = TOGGLE_MENU_TOPIC;
    public forceCloseMenuTopic = FORCE_CLOSE_MENU_TOPIC;

    public created() {
        this.subscribeToBus(TOGGLE_MENU_TOPIC, () => {
            this.menuOpened = !this.menuOpened;
        })
    }

    public beforeDestroy() {
        super.beforeDestroy();
    }

    public goToCurrentReports() {
        router.push({ name: Routes.CURRENT_REPORTS });
    }

    public goToCloseReports() {
        router.push({ name: Routes.CLOSE_REPORTS });
    }

    public goToSearch() {
        router.push({ name: Routes.CONDITION_REPORT_HOME });
    }

    public toggleMenu() {
        this.emitOnBus(TOGGLE_MENU_TOPIC);
    }

    private checkCurrentRoute(routeName) {
        return this.$route.path === routeName;
    }

    @Watch('$route', { immediate: true, deep: true })
    private onRouteChange($route) {
        this.routeHasMenu = !!$route.matched.find(match => !!match.components.actionMenu);
        if (!this.routeHasMenu) {
            this.emitOnBus(FORCE_CLOSE_MENU_TOPIC);
            this.menuOpened = false;
        }
    }
}
